import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../lib/supabase';
import type { AuthState, AuthContextType } from './types';

const ADMIN_EMAIL = 'contact@parakhservices.com';
const ADMIN_PASSWORD = 'ab12cd34e5';

export function useAuth(): AuthContextType {
  const [state, setState] = useState<AuthState>({
    user: null,
    isAdmin: false,
    loading: true,
    error: null
  });

  const login = useCallback(async (email: string, password: string) => {
    try {
      // Validate against hardcoded credentials
      if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
        setState({
          user: { id: '1', email: ADMIN_EMAIL, role: 'admin' },
          isAdmin: true,
          loading: false,
          error: null
        });
        return true;
      }
      setState(prev => ({
        ...prev,
        error: 'Invalid credentials'
      }));
      return false;
    } catch (error) {
      console.error('Login error:', error);
      setState(prev => ({
        ...prev,
        error: 'Login failed'
      }));
      return false;
    }
  }, []);

  const logout = useCallback(async () => {
    setState({
      user: null,
      isAdmin: false,
      loading: false,
      error: null
    });
  }, []);

  useEffect(() => {
    // Check for existing session
    setState(prev => ({ ...prev, loading: false }));
  }, []);

  return {
    ...state,
    login,
    logout
  };
}